export { QuoteTabs } from '../QuoteTabs/QuoteTabs';
export { DailyDollar } from '../DailyDollar/DailyDollar';
export { DailyWeather } from '../DailyWeather/DailyWeather';
export { DailyPecuária } from '../DailyQuoteBr/DailyPecuária';
export { DailyAgricultura } from '../DailyQuoteBr/DailyAgricultura'